"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ItemHeader_1 = require("./ItemHeader");
var MessageBody_1 = require("./MessageBody");
var SubjectHeader_1 = require("./SubjectHeader");
var owa_mail_messagead_store_1 = require("owa-mail-messagead-store");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var React = require("react");
var styles = require('./MessageAdReadingPane.scss');
var classNames = require('classnames/bind').bind(styles);
var MessageAdReadingPane = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdReadingPane, _super);
    function MessageAdReadingPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageAdReadingPane.prototype.render = function () {
        var currentMessageAd = owa_mail_messagead_store_1.getStore().messageAdRowStore.get(this.props.selectedAdRowId);
        var adSender = currentMessageAd.adSender;
        var adSubject = currentMessageAd.adSubject;
        var adTextsAboveImage = currentMessageAd.adTextsAboveImage;
        var adTextsOnImage = currentMessageAd.adTextsOnImage;
        var adCallToActionTextsOnImage = currentMessageAd.adCallToActionTextsOnImage;
        var adCallToActionTextsBelowImage = currentMessageAd.adCallToActionTextsBelowImage;
        // Delay load the Default Outlook Ad related string
        if (currentMessageAd.adType === "OutlookUpSell" /* OutlookUpSell */) {
            adSender = owa_messagead_strings_1.default.outlookAdSenderText;
            adSubject = owa_messagead_strings_1.default.outlookAdSubject;
            adTextsAboveImage = owa_messagead_strings_1.default.outlookAdPreview;
            adCallToActionTextsBelowImage = owa_messagead_strings_1.default.generalCallToAction;
        }
        return (React.createElement("div", { className: classNames(styles.absolutePosition) },
            React.createElement("div", { className: classNames(styles.flexContainer) },
                React.createElement("div", null,
                    React.createElement(SubjectHeader_1.default, { subject: adSubject, originalPrice: currentMessageAd.adOriginalPrice, currentPrice: currentMessageAd.adCurrentPrice }),
                    React.createElement("div", { className: styles.scrollRegionContainer },
                        React.createElement("div", { className: classNames(styles.scrollRegion, 'customScrollBar') },
                            React.createElement(ItemHeader_1.default, { adSender: adSender, adFavIconurl: currentMessageAd.adFavIconurl }),
                            React.createElement(MessageBody_1.default, { adTextsAboveImage: adTextsAboveImage, adTextsOnImage: adTextsOnImage, adCallToActionTextsOnImage: adCallToActionTextsOnImage, adCallToActionTextsBelowImage: adCallToActionTextsBelowImage, adImageUrl: currentMessageAd.adImageUrl, adImageTargetUrl: currentMessageAd.adImageTargetUrl, adTextsToRenderBody: currentMessageAd.adTextsToRenderBody, adType: currentMessageAd.adType, adMarket: currentMessageAd.adMarket, adRefreshEvent: currentMessageAd.adRefreshEvent })))))));
    };
    return MessageAdReadingPane;
}(React.Component));
exports.default = MessageAdReadingPane;
//# sourceMappingURL=MessageAdReadingPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/MessageAdReadingPane.js
// module id = 5555
// module chunks = 17